import { Typography } from '@/ui-kit';
import styles from './profile-verification-section.module.scss';
import { ArrowBackUpIcon, ErrorNotificationIcon, VerifiedAccountIcon } from '@/assets/icons';
import { useState } from 'react';
import { profilesApi } from '@/api';
import { useToast } from '@/store/useToast';
import { useAuth } from '@/store/useAuth';
import { SelfInitiatedVerificationBottomsheet } from '../self-initiated-verification-bottomsheet';

export const ProfileVerificationSection = () => {
    const showToast = useToast((state) => state.show);

    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);

    const userData = useAuth((state) => state.getUser());    
    const setUserData = useAuth((state) => state.setProfile);
    
    const onVerificationBottomsheetOkClicked = async () => {
        try {
            await profilesApi.selfInitiateVerification()
            setUserData({ ...userData, verification_status: 'self_initiated' })
            return true
        } catch (e) {
            showToast({
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка. Попробуйте ещё раз'
            });
        }
        return false
    }

    return (
        <>
            <div className={styles.profileVerificationCard} onClick={() => setIsVerificationModalOpen(true)}>
                <div className={styles.profileVerificationCardMain}>
                    <Typography
                        variant="span"
                        fontWeight="bold"
                        className={styles.profileVerificationCardMainTitle}>
                        Пройди верификацию
                    </Typography>
                    <Typography
                        variant="span"
                        fontWeight="normal"
                        typeColor="gray-label"
                        className={styles.profileVerificationCardMainSubtitle}>
                        Аккаунт с верификацией повысит твои шансы на мэтч
                    </Typography>
                </div>
                <VerifiedAccountIcon className={styles.profileVerificationCardIcon} />
                <ArrowBackUpIcon className={styles.arrowIcon} />
            </div>        
            <SelfInitiatedVerificationBottomsheet
                isVerificationModalOpen={isVerificationModalOpen}
                setIsVerificationModalOpen={setIsVerificationModalOpen}
                onOkClicked={onVerificationBottomsheetOkClicked} />
        </>
    )
}
